module.exports = __webpack_public_path__ + "img/rockport-hobie.83d1e8f2.jpg";